// extracted by mini-css-extract-plugin
module.exports = {"accordionGroup":"accordion-group-module--accordion-group--3q3Om","heading":"accordion-group-module--heading--1HBK8","accordionItem":"accordion-group-module--accordion-item--al-zS"};